export const presetProducts = [
    { id: 'price_1RLNYIBzi8BGoIWUqMtCReL5', label: 'Expense Contribution - $49/per month' },
    { id: 'price_1RLNd3Bzi8BGoIWUf9Wrt6w6', label: 'AZ Managed "Lite" - $199/per month' },
    // Additional dummy products can be added here
];